import { ApplicationContext } from '@upside/spa-shared-context';

import { start } from 'single-spa';

import { handleExternalRedirect } from '../event-handlers/external-redirect';
import { paths } from './const';

const UNAUTHENTICATED_PATHS = [
  `/${paths.LOGIN}`,
  `/${paths.VERIFY_MANAGED_SUBSCRIPTION}`,
];

export default (context: ApplicationContext): void => {
  if (window.location.pathname.startsWith(`/${paths.REDIRECT}`)) {
    handleExternalRedirect(context.authentication.loggedIn);
  } else if (
    !context.authentication.loggedIn &&
    !UNAUTHENTICATED_PATHS.some((path) =>
      window.location.pathname.startsWith(path),
    )
  ) {
    const redirectTo = `${window.location.pathname}${
      window.location.search ?? ''
    }`;
    const redirect = new URLSearchParams({ redirectTo });
    window.location.replace(`/${paths.LOGIN}?${redirect.toString()}`);
  } else if (
    context.authentication.loggedIn &&
    window.location.pathname.startsWith(`/${paths.LOGIN}`)
  ) {
    window.location.replace('/');
  } else {
    start();
  }
};
